import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    avatarUploadContainer: {
        display: "inline-block",
        position: "relative",
        width: "4rem",
        height: "4rem",
    },
    menuButton: {
        backgroundColor: theme.colors.violet[0],
        border: `0.75px solid ${theme.colors.gray[3]}`,
        position: "absolute",
        right: 0,
        bottom: 0,
    },
    uploadButton: {
        "&:hover": {
            color: theme.colors.primary[8],
            transition: "0.2s ease-in",
            transitionProperty: "background-color, color",
        },
    },
    removeButton: {
        "&:hover": {
            backgroundColor: theme.colors.red[0],
            transition: "background-color 0.2s ease-in",
        },
    },
}))
